let isSm = false // less than 640px
let isMd = false // between 641px and 768px
let isLg = false // between 769px and 1280px
let isXl = false // greater than 1280px


/**
 * Update media queries
 * 
 * @returns {void}
 */
function updateMediaQueries() {
    // console.log('updateMediaQueries')
    isSm = window.matchMedia('(max-width: 640px)').matches
    isMd = window.matchMedia('(min-width:641px) and (max-width: 768px)').matches
    isLg = window.matchMedia('(min-width: 769px) and (max-width: 1280px)').matches
    isXl = window.matchMedia('(min-width: 1280px)').matches
}

// listen for changes when the window is resized
window.addEventListener('resize', updateMediaQueries);
updateMediaQueries()

// export
export { isSm, isMd, isLg, isXl, updateMediaQueries }
